import { render, staticRenderFns } from "./AiChatCapabilities.vue?vue&type=template&id=12b1993a&scoped=true&"
import script from "./AiChatCapabilities.vue?vue&type=script&lang=js&"
export * from "./AiChatCapabilities.vue?vue&type=script&lang=js&"
import style0 from "./AiChatCapabilities.vue?vue&type=style&index=0&id=12b1993a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b1993a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VIcon})
